import * as React from 'react';
import { useDIContainer } from '../hooks/useDIContainer';
import { useLoginMachineService } from './LoginMachineServiceProvider';

const useAuth = (): Bluebeam.Auth.Models.Credentials => {
  const { authService } = useDIContainer();
  const [credentials, setCredentials] =
    React.useState<Bluebeam.Auth.Models.Credentials>(() =>
      authService.isLoggedIn()
        ? authService.getCredentials()
        : {
            accessToken: '',
            displayName: '',
            email: '',
            idToken: '',
            userId: '',
          }
    );

  const [state] = useLoginMachineService();

  React.useEffect(() => {
    if (
      !state.matches('loggedIn') &&
      !state.matches({ loggedInWithRefresh: 'idle' })
    ) {
      return;
    }

    setCredentials(authService.getCredentials());
  }, [state, authService]);

  return credentials;
};

export { useAuth };
